import ActivityUniversities from "./ActivityUniversities";

export default ActivityUniversities;